import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { KPI } from '../../../@core/api';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { PriceSheetsListComponent } from '../price-sheets-list/price-sheets-list.component';
import { PriceSheetFormComponent } from '../side-forms/price-sheet-form/price-sheet-form.component';
import { PriceSheetService, UsersService } from '../../../@core/utils';
import { RightPanelDialogService } from '../../../@core/utils/right-panel-dialog.service';
import { PriceTier } from '../../../@core/utils/auto-ppa.service';
import { GROUP_PERMISSION_EDIT_PRICE_SHEET } from '../../../@core/api/models';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-price-sheets-list-dialog',
    templateUrl: './price-sheets-list-dialog.component.html',
    styleUrls: ['./price-sheets-list-dialog.component.scss'],
    standalone: true,
    imports: [NbCardModule, PriceSheetsListComponent, NbButtonModule, TranslateModule]
})
export class PriceSheetsListDialogComponent implements OnInit, OnDestroy {

  @Input() priceSheets: KPI.PriceSheet[];
  @Input() assetType: KPI.MappedAssetType;
  @Input() assetId: number;
  @Input() assetQuantity: number;
  @Input() isPPA: boolean = true;
  private hasParams: boolean = false;
  private newPSCount: number = null;
  private customerPsDeleted: boolean = false;
  private selectedPriceTier: PriceTier;
  private subscriptions: Subscription[] = [];
  public canEdit: boolean;

  constructor(
    private ref: NbDialogRef<PriceSheetsListDialogComponent>,
    private rightPanelDialogService: RightPanelDialogService,
    private usersService: UsersService,
    private priceSheetsService: PriceSheetService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.usersService.hasCurrentUserPermissions([GROUP_PERMISSION_EDIT_PRICE_SHEET]).subscribe((canEdit) =>
        this.canEdit = canEdit
      ),
      this.priceSheetsService._pricesheetsHaveChanged$.subscribe(() => {
        this.priceSheetsService.getPriceSheetsByAssetType(this.assetType.id).subscribe((priceSheets) => {
          this.hasPriceSheetsChanged(priceSheets.length)
        })
      })
    )
  }

  public hasPriceSheetsChanged(psCount) {
    this.hasParams = true;
    this.newPSCount = psCount;
  }

  public customerPsRemoved(customerPsDeleted) {
    this.customerPsDeleted = customerPsDeleted
  }

  public onPriceTierChanged(tier: PriceTier): void {
    this.selectedPriceTier = tier;
  }

  public close(): void {
    if (this.hasParams || this.selectedPriceTier) {
      this.ref.close({
        priceSheetsChanges: this.hasParams,
        psTotal: this.newPSCount,
        customerPsDeleted: this.customerPsDeleted,
        selectedPriceTier: this.selectedPriceTier,
      });
    } else {
      this.ref.close()
    }
  }

  public closeWithParams(): void {
    this.ref.close({
      priceSheetsChanges: true,
      psTotal: 0,
      customerPsDeleted: this.customerPsDeleted
    })
  }

  public addPriceSheet() {
   this.rightPanelDialogService.open(
      PriceSheetFormComponent,
      {
        autoFocus: false,
        closeOnBackdropClick: false,
        context: {
          assetType: this.assetType,
          isDefault: this.priceSheets.length === 0
        },
      },
    )
  }

  public createBreadCrumb(): string {
    return this.assetType.super_category.name + ' > ' + this.assetType.category.name + ' > ' + this.assetType.sub_category.name
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
